var _style, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiverr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1A1A1A;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 250,
    cy: 250,
    r: 244.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.1,137.1c0,16.2-13.3,29.6-29.6,29.6c-16.6,0-29.9-13.1-29.9-29.7c0-16.7,13-29.8,29.7-29.8 C334.9,107.3,348.1,120.5,348.1,137.1z M375.4,333.5c0.1-4-1.4-5.2-5.3-5c-6.9,0.3-13.8,0.1-21.3,0.1v-6.2c0-42.5,0-85.1,0-127.7 c0-7,0-7-7-7c-40.5,0-81,0-121.5,0c-10.6,0-9.1,0.9-9.1-9.1c-0.1-12.7,6.3-19.2,19-19.6c5.7-0.2,11.4-0.2,17.1,0 c3.1,0.1,4.1-1.1,4-4.2c-0.2-7.4,0-14.9,0-22.3v-20.3c-11.7,0-22.7-0.4-33.7,0.1c-7.2,0.3-14.6,1-21.5,3c-22,6.3-38.7,19-44.4,42.2 c-2,8.3-1.3,17.3-1.5,25.9c-0.1,3-1,4.3-4.1,4.2c-5.8-0.1-11.7,0-17.6,0c-2.7,0-4,1-4,3.9c0.1,12,0.1,24,0,36.1c0,2.8,1,4,3.9,3.9 c5.4-0.2,10.8,0.2,16.1-0.1c4.2-0.3,5.7,0.9,5.7,5.5c-0.2,28.8-0.1,57.6-0.1,86.4c0,1.7-0.2,3.3-0.3,5.3c-7.3,0-14.1,0.2-20.8-0.1 c-3.3-0.1-4.5,1.1-4.4,4.3c0.1,12.2,0.1,24.4,0,36.5c0,3.1,0.8,4.5,4.3,4.5c34.6-0.1,69.3-0.1,103.9,0c3.4,0,4.3-1.2,4.2-4.4 c-0.2-11.7-0.3-23.4,0-35.1c0.1-4.5-1.2-6.1-5.8-5.9c-6.6,0.4-13.1,0.1-19.7,0.1c-0.2-1.6-0.3-2.4-0.3-3.2c0-29.7,0.1-59.5-0.1-89.2 c0-4.4,2.3-4.4,5.4-4.4c22,0,44,0.1,66,0c4.1,0,5.4,1.2,5.4,5.4c-0.2,28.8-0.1,57.6-0.1,86.4c0,1.5-0.2,3.1-0.3,5.2h-24.1v44.7 h111.5c0.2-1.6,0.4-3,0.4-4.4C375.3,357.2,375.2,345.3,375.4,333.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiverr);
export default __webpack_public_path__ + "static/media/fiverr.8d35a412afce9f71b6cc8babe4100ea5.svg";
export { ForwardRef as ReactComponent };